export const onEnter = () => {
  document.querySelectorAll('.tooltip.show').forEach((element) => {
    element.classList.add('hide');
    element.classList.remove('show');
  });
};

export const onExit = () => {
  document.querySelectorAll('.tooltip.hide').forEach((element) => {
    element.classList.add('show');
    element.classList.remove('hide');
  });
}
